export default __webpack_public_path__ + "assets/19a679cb7848125056d868d0a7f9c236.png";